import { render, staticRenderFns } from "./ProgressiveLoader.vue?vue&type=template&id=56f9b0e3&scoped=true"
import script from "./ProgressiveLoader.vue?vue&type=script&lang=js"
export * from "./ProgressiveLoader.vue?vue&type=script&lang=js"
import style0 from "./ProgressiveLoader.vue?vue&type=style&index=0&id=56f9b0e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f9b0e3",
  null
  
)

export default component.exports